import React, { useState, useEffect, useRef } from 'react';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import {
    Container,
    Grid,
    CircularProgress,
    Accordion
} from '@material-ui/core';

import {
    GenerteOTP as GenerateOTPForAutoTransferSetting,
    AddWithOTP as AUTOBalanceSetting_WITH_OTP,
    SelectSetting,
    Update as SETTING_UPDATE,
    DeleteSetting,
    GenerateOTPForSettingUpdate
} from 'Components/Api/AutoBalanceTransferAPI';

import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';
import HOCLoader from 'Components/Loader/HOCLoader';
import HOCAccordion from 'Components/CustomAccordion/HOCAccordion';
import { logout } from 'Components/Helper/Helpers';
import { SelectDirectDownline } from 'Components/Api/UsersApi';
import AsyncAutoComplete from 'Components/Inputes/AsyncAutoComplete';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import { OTPModal } from 'Components/Modal/OTPModal';
import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';

const CustomAccordion = HOCAccordion(Accordion);
const CustomContainer = HOCLoader(Container);

export const AutoBalanceTransfer = () => {
    const formRef = useRef();
    const classes = commonStyle();

    const [tableItems, setTableItems] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [modalErrorMessage, setModalErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');

    const [currentPage, setCurrentPage] = useState(0);

    const [openFilter, setOpenFilter] = useState(true);
    const [TakeCount, setTakeCount] = useState(100);
    const [SkipCount, setSkipCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [IsFetchAllList, setisFetchAllList] = useState(false);
    const [downline, setDownline] = useState([]);
    const [openOTP, setOpenOTP] = useState(false);
    const [openOTPForUpdate, setOpenOTPForUpdate] = useState(false);
    const [SelectedUser, setSelectedUser] = useState(0);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [updateRequest, setUpdateRequest] = useState([]);

    const [userDefault, setUserDefault] = useState({
        UserID: 0,
        FirmName: 'Select User'
    });
    const [ModelObj] = useState({
        User: userDefault,
        DMTAmountIncreasedBy: 0,
        DMTLowBalanceReached: 0,
        RechargeAmountIncreasedBy: 0,
        RechargeLowBalanceReached: 0,
        MaxOutstanding: 0
    });

    const callSearch = async (text) => {
        if (
            text === undefined ||
            text === null ||
            text === '' ||
            text.length <= 0 ||
            text === userDefault.FirmName
        )
            return;

        selectDownline(text);
    };

    const isValidToRefreshList = (list) => {
        if (IsFetchAllList === false) {
            return true;
        }

        if (list === undefined || list === null) {
            return true;
        }

        if (list.length <= 1) {
            return true;
        }

        return false;
    };

    const selectDownline = async (values) => {
        if (IsFetchAllList === true) {
            values = '';
        }

        var jsonObj = {
            FirmName: values
        };

        if (isValidToRefreshList(downline) === false) {
            return;
        }

        setLoading(true);
        var request = JSON.stringify(jsonObj);
        setLoading(false);
        const response = await SelectDirectDownline(request);
        if (!response.isAuthorized) logout();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [userDefault, ...data];

        setDownline(objWithSelectAll);
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setTableItems([]);

        let request = {
            UserID: values.User.UserID
        };

        let requestJSON = JSON.stringify(request);

        const {
            data,
            status,
            isAuthorized
        } = await GenerateOTPForAutoTransferSetting(requestJSON);

        setLoading(false);
        if (!isAuthorized) logout();
        if (!status) {
            setIsError(true);
            setResponseMessage(data);
            setSeverity('error');
            return;
        }
        var d = JSON.parse(data);

        if (d.IsOTPSent) {
            setOpenOTP(true);
            setIsError(true);
            setResponseMessage(d.Message);
            setSeverity('success');
            setSelectedUser(values.User.UserID);
            return;
        }

        setIsError(true);
        setResponseMessage(d.Message);
        setSeverity('error');
        return;
    };

    const validationSchema = Yup.object({
        User: Yup.object()
            .nullable(PLEASE_SELECT_VALID + ' User')
            .required(PLEASE_SELECT_VALID + ' User')
            .shape({
                UserID: Yup.string()
                    .notOneOf(['0'], PLEASE_SELECT_VALID + 'User')
                    .required(PLEASE_SELECT_VALID + 'User')
            })
    });

    const passAutBalanceTransferOTP = async (otpObj) => {
        setLoading(true);
        setOpenOTP(false);
        setModalErrorMessage('');

        const { OTP } = otpObj;

        let RequestObj = {
            OTP: OTP,
            SelectedUserID: SelectedUser
        };
        var response = await AUTOBalanceSetting_WITH_OTP(
            JSON.stringify(RequestObj)
        );
        setLoading(false);
        if (!response.status) {
            setLoading(false);
            setOpenOTP(true);
            setModalErrorMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        setSeverity('success');
        setResponseMessage(data.Message);
        setIsError(true);

        setOpenOTP(false);

        SelectData();
    };

    const SelectData = async () => {
        setLoading(true);
        setTableItems([]);
        setLoading(false);
        const userResponse = await SelectSetting();

        if (!userResponse.isAuthorized) logout();

        if (!userResponse.status) {
            setIsError(true);
            setSeverity('error');
            return;
        }
        var data = JSON.parse(userResponse.data);
        setTableItems(data);
    };

    useEffect(() => {
        SelectData();
        createColumns();
    }, []);

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'AutoTransferUserwiseMappingID',
            srno: true
        });
        columns.push({
            label: 'FirmName',
            name: 'FirmName'
        });
        columns.push({
            label: 'DMTAmt ++',
            name: 'DMTAmountIncreasedBy',
            textwrapwidth: 100,
            editable: true,
            editableForUpdate: true
        });
        columns.push({
            label: 'DMTLowBalanceReached',
            name: 'DMTLowBalanceReached',
            textwrapwidth: 100,
            editable: true,
            editableForUpdate: true
        });

        columns.push({
            label: 'RechargeAmt ++',
            name: 'RechargeAmountIncreasedBy',
            textwrapwidth: 100,
            editable: true,
            editableForUpdate: true
        });

        columns.push({
            label: 'RechargeLowBalanceReached',
            name: 'RechargeLowBalanceReached',
            textwrapwidth: 100,
            editable: true,
            editableForUpdate: true
        });

        columns.push({
            label: 'MaxOutstanding',
            name: 'MaxOutstanding',
            textwrapwidth: 100,
            editable: true,
            editableForUpdate: true
        });

        columns.push({
            label: 'ParentID',
            name: 'ParentID',
            hide: true
        });

        columns.push({
            label: 'UserID',
            name: 'UserID',
            hide: true
        });

        columns.push({
            label: 'Update',
            name: 'AutoTransferUserwiseMappingID',
            save: true,
            buttonTitle: 'Update',
            callback: (value) => {
                GenerateOTPForUpdate(value);
            }
        });

        columns.push({
            label: 'Delete',
            name: 'AutoTransferUserwiseMappingID',
            delete: true,
            callback: (value) => {
                onDeleteClick(value);
            }
        });

        setMainColumns(columns);
    };

    const onDeleteClick = (item) => {
        var RequestObj = { AutoTransferUserwiseMappingID: item };
        setIsAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };

    const Delete = async (request) => {
        var jsonReq = JSON.stringify(request);
        setLoading(true);
        const response = await DeleteSetting(jsonReq);
        setLoading(false);

        if (!response.isAuthorized) logout();

        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);
        if (!response.status) setSeverity('error');

        SelectData();
    };

    const autoBalanceValidation = Yup.object({
        DMTAmountIncreasedBy: Yup.number().required(
            PLEASE_PROVIDE_VALID + 'DMTAmountIncreasedBy Amount'
        ),

        DMTLowBalanceReached: Yup.number().required(
            PLEASE_PROVIDE_VALID + 'DMTLowBalanceReached Amount'
        ),

        RechargeAmountIncreasedBy: Yup.number().required(
            PLEASE_PROVIDE_VALID + 'RechargeAmountIncreasedBy Amount'
        ),

        RechargeLowBalanceReached: Yup.number().required(
            PLEASE_PROVIDE_VALID + 'RechargeLowBalanceReached Amount'
        ),

        MaxOutstanding: Yup.number().required(
            PLEASE_PROVIDE_VALID + 'MaxOutstanding Amount'
        )
    });

    const deleteConfirmation = (
        <ConfirmAlert
            isOpen={isAlertOpen}
            title="Delete Confirmation"
            message="Are you sure to delete this setting?"
            request={confirmAlertRequest}
            positiveButtonClick={(request) => {
                setIsAlertOpen(false);
                Delete(request);
            }}
            negativeButtonClick={() => {
                setIsAlertOpen(false);
            }}
        />
    );

    const GenerateOTPForUpdate = async (value) => {
        setUpdateRequest(value);
        var RequestObj = { UserID: value[7] };

        var request = JSON.stringify(RequestObj);

        const response = await GenerateOTPForSettingUpdate(request);
        setLoading(false);

        if (!response.isAuthorized) logout();

        setLoading(false);

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }

        var d = JSON.parse(response.data);

        if (d.IsOTPSent) {
            setOpenOTPForUpdate(true);
            setIsError(true);
            setResponseMessage(d.Message);
            setSeverity('success');
            setSelectedUser(value[8]);
            return;
        }

        setIsError(true);
        setResponseMessage(d.Message);
        setSeverity('error');
        return;
    };

    const UpdateClick = async (OTP) => {
        let jsonObj = {
            AutoTransferUserwiseMappingID: updateRequest[0],
            DMTAmountIncreasedBy: updateRequest[2],
            DMTLowBalanceReached: updateRequest[3],
            RechargeAmountIncreasedBy: updateRequest[4],
            RechargeLowBalanceReached: updateRequest[5],
            MaxOutstanding: updateRequest[6],
            ParentID: updateRequest[8],
            UserID: updateRequest[9],
            OTP: OTP.OTP
        };

        var errorValidation = false;
        await autoBalanceValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
            return;
        });

        if (errorValidation === true) return;

        var request = JSON.stringify(jsonObj);
        setIsError(false);
        setLoading(true);
        const { isAuthorized, status, data } = await SETTING_UPDATE(request);
        setLoading(false);

        if (!isAuthorized) logout();

        if (!status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(data);

            return;
        }
        setSeverity('success');
        setResponseMessage(data);
        setIsError(true);

        setOpenOTPForUpdate(false);
        SelectData();
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                innerRef={formRef}
                initialValues={ModelObj}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                resetForm={ModelObj}
            >
                {({ setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <Grid item xs={12}>
                                <CustomAccordion
                                    title={'Auto balance transfer setting'}
                                    open={openFilter}
                                    setOpen={(value) => setOpenFilter(value)}
                                >
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <Field
                                                component={AsyncAutoComplete}
                                                defaultValue={userDefault}
                                                FieldName="User"
                                                name="User"
                                                SubFieldName="UserID"
                                                options={downline}
                                                getOptionLabel={(option) =>
                                                    option.FirmName
                                                }
                                                textFieldProps={{
                                                    label: 'Select User'
                                                }}
                                                onSearchCallback={(text) => {
                                                    callSearch(text);
                                                }}
                                                onCustomCallback={(
                                                    name,
                                                    value
                                                ) => {
                                                    setUserDefault({
                                                        UserID: value.UserID,
                                                        FirmName: value.FirmName
                                                    });
                                                }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={2}
                                            lg={2}
                                        >
                                            <PrimaryButton
                                                type="submit"
                                                title="Generate OTP"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                disabled={loading}
                                            >
                                                Generate OTP
                                            </PrimaryButton>
                                            {loading && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                </CustomAccordion>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
            {openOTP ? (
                <OTPModal
                    isOpen={openOTP}
                    title="OTP"
                    error={modalErrorMessage}
                    submitCallback={(value) => {
                        passAutBalanceTransferOTP(value);
                    }}
                    resendCallback={(value) => {}}
                    onDismissCallback={(value) => {
                        setOpenOTP(value);
                    }}
                />
            ) : null}

            {openOTPForUpdate ? (
                <OTPModal
                    isOpen={openOTPForUpdate}
                    title="OTP"
                    error={modalErrorMessage}
                    submitCallback={(value) => {
                        UpdateClick(value);
                    }}
                    resendCallback={(value) => {}}
                    onDismissCallback={(value) => {
                        setOpenOTPForUpdate(value);
                    }}
                />
            ) : null}
            <ReactTable
                data={tableItems}
                columns={mainColumns}
                count={totalCount}
                rowsPerPage={TakeCount}
                serverSide={true}
                getCallback={({ currentPage, RowsPerPage }) => {
                    setCurrentPage(currentPage);
                    setTakeCount(RowsPerPage);
                    setSkipCount(RowsPerPage * currentPage);
                }}
                getSearchCallback={({ SearchText }) => {}}
                getSortCallback={({ column, direction }) => {}}
            />
            {isAlertOpen ? deleteConfirmation : null}
        </CustomContainer>
    );
};
